import React, { Component } from 'react';
import {
	IResetPasswordProps,
	IResetPasswordState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import ErrorMessage from '../App/styledComponents/ErrorMessage';
import SuccessMessage from '../App/styledComponents/SuccessMessage';
import ButtonRaised from '../App/styledComponents/ButtonRaised';
import { ResetPasswordStore } from './stores/ResetPasswordStore';
import { ActionTiles } from '../App/models/ActionTiles';

@inject('appStore', 'resetPasswordStore', 'messageStore')
@observer
export class ResetPassword extends Component<IResetPasswordProps, IResetPasswordState> {
	static configurationKey: 'resetPassword' = 'resetPassword';
	static styleKey: 'resetPassword' = 'resetPassword';
	constructor(props: IResetPasswordProps) {
		super(props);
	}

	render() {
		const { className, resetPasswordStore, messageStore, appStore } = this.props;
		const { componentKey } = ResetPasswordStore;

		if (!resetPasswordStore || !messageStore || !appStore) {
			return null;
		}

		if (!appStore.isActionEnabled(ActionTiles.RESET_PASSWORD)) {
			return null;
		}

		const { resetPasswordCardProps } = appStore;
		const { errorTexts, infoTexts } = messageStore;

		return (
			<Wrapper className={ className } { ...resetPasswordCardProps }>
				<ButtonRaised onClick={ resetPasswordStore.onSubmitPasswordResetRequest } data-qa-ref="requestPasswordResetButton">
					{ resetPasswordStore.resetPasswordButtonText }
				</ButtonRaised>
				<ErrorMessage data-qa-ref="resetPasswordError" >
					{ errorTexts.get(componentKey) }
				</ErrorMessage>
				<SuccessMessage data-qa-ref="resetPasswordInfo">
					{ infoTexts.get(componentKey) }
				</SuccessMessage>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(ResetPassword, 'resetPassword');

